// extracted by mini-css-extract-plugin
module.exports = {"reco":"reco--74cX8","reco_banner":"reco_banner--3oX8W","recommend":"recommend--2wZu1","recommend_banner_weekhot":"recommend_banner_weekhot--3R3xs","loading":"loading--lI8Za"};